export const useUserInfoStore = defineStore('userInfo', () => {
  const userInfo = ref({})

  async function getUserInfo() {
    const { data } = await request('/website/tourism/user/view')
    userInfo.value = data
  }
  return {
    userInfo,
    getUserInfo
  }
})
